// Lotteries analytics          DL1.70

import { DataLayer } from "@sazka/utils/data-layer";

// Online tickets analytics     DL1.70
export function initializeNavigationAnalytics() {
    const nav = document.getElementById("ds-secondary-menu");
    if (!nav) return;

    const links = nav.querySelectorAll(".ds-secondary-menu__item a");
    links.forEach((link) => {
        if (link.classList.contains("ds-secondary-menu__link--highlighted")) {
            return;
        }

        link.addEventListener(
            "click",
            () => {
                const navTitle = link
                    .closest(".ds-secondary-menu__item")
                    .querySelector(".ds-secondary-menu__title")
                    ?.textContent?.trim();
                if (navTitle) {
                    DataLayer.pushInstant({
                        event: "action.click.navigation",
                        action: {
                            click: {
                                name: navTitle,
                                eventProperty1: "sub",
                                eventProperty2: "sub",
                            },
                        },
                    });
                }
            },
            { once: true }
        );
    });

    const searchButton = nav.querySelector(".ds-secondary-menu__search-button");
    searchButton?.addEventListener("click", () => {
        DataLayer.pushInstant({
            event: "action.click.navigation",
            action: {
                click: {
                    name: "Hledat",
                    eventProperty1: "sub",
                    eventProperty2: "sub",
                },
            },
        });
    });
}
